import { render, staticRenderFns } from "./modalIntegrantesEquipo.vue?vue&type=template&id=31ff00cb&"
import script from "./modalIntegrantesEquipo.vue?vue&type=script&lang=js&"
export * from "./modalIntegrantesEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports